
/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

$(document).ready(function(){
$('.accordion-header').click(function(event){
event.preventDefault();
var $accordionSection = $(this).closest('.accordion-section');
$accordionSection.siblings().find('.accordion-content').slideUp();
// $accordionSection.find('.accordion-content').slideToggle();
$accordionSection.find('.accordion-content').slideToggle('800', function() {
if ($(this).is(':visible')) {
$("body").addClass("overflow-hidden-custom");
} else {
$("body").removeClass("overflow-hidden-custom");
}
});
$accordionSection.find('.accordion-content').toggleClass("active");
// $("body").toggleClass("overflow-hidden-custom");
$(".accordion-header").not(this).removeClass("header-btn-active");
$(this).toggleClass("header-btn-active");
});
$(document).click(function(event) {
if (!$(event.target).closest('.accordion-header').length && !$(event.target).closest('.accordion-content').length) {
$(".accordion-content").slideUp(300); // Slide up if clicked outside of the button and box
$("body").removeClass("overflow-hidden-custom");
$(".accordion-header").removeClass('header-btn-active');
}
});

});



// best seller slider

$(document).ready(function () {
  function initSlickSlider() {
    const $slider = $('.bestseller-product-wrapper');

    $slider.slick({
      autoplay: false,
      arrows: true,
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  initSlickSlider();

  $('.bestseller-tab').on('click', function () {
    const $slider = $('.bestseller-product-wrapper');

    $slider.css('visibility', 'hidden'); 
    setTimeout(function () {
      if ($slider.is(':visible')) {
        $slider.slick('refresh');
        $slider.css('visibility', 'visible'); 
      }
    }, 300); 
  });

  $(window).on('resize', function () {
    $('.bestseller-product-wrapper').slick('refresh');
  });

});



